import {
  MANAGE_LEAVE_BALANCE_REQUEST,
  MANAGE_LEAVE_BALANCE_REQUEST_ERROR,
  MANAGE_LEAVE_BALANCE_REQUEST_SUCCESS,
} from '../actionType/type';

const initialState = {
  data: null,
  isLoading: false,
  refreshPage: false,
};

export const manageLeaveBalanceReducer = (state = initialState, action) => {
  let object;
  switch (action.type) {
    case MANAGE_LEAVE_BALANCE_REQUEST:
      object = {
        ...state,
        isLoading: true,
      };
      break;
    case MANAGE_LEAVE_BALANCE_REQUEST_ERROR:
      object = {
        ...state,
        isLoading: false,
      };
      break;
    case MANAGE_LEAVE_BALANCE_REQUEST_SUCCESS:
      object = {
        ...state,
        data: action.payload,
        isLoading: false,
      };
      break;
    // case FORM_REFRESH:
    //   object = {
    //     ...state,
    //     refreshPage: !state.refreshPage,
    //   };
    //   break;


    default:
      object = state;
      break;
  }

  return object;
};
